import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane, faPhoneSquare } from "@fortawesome/free-solid-svg-icons";
import { faLinkedin, faGithub, faXTwitter } from "@fortawesome/free-brands-svg-icons";
import emailjs from "emailjs-com";
import { useTranslation } from "react-i18next";
import "./contact.scss";

function Contact() {
  const { t } = useTranslation();
  const [msg, setMsg] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [honeypot, setHoneypot] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (honeypot) {
      console.log("Spam détecté !");
      return;
    }

    const templateParams = {
      from_name: name,
      reply_to: email,
      message: message,
    };

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_EMAILJS_USER_ID
      )
      .then((response) => {
        console.log("SUCCESS!", response.status, response.text);
        setMsg(true);
        setErrorMsg("");
        setTimeout(() => {
          setMsg(false);
          setName("");
          setEmail("");
          setMessage("");
        }, 3000);
      })
      .catch((err) => {
        console.error("FAILED...", err);
        setErrorMsg(t("contactForm.errorMessage"));
      });
  };

  return (
    <>
    <div id="contact" style={{ minHeight: "100vh", padding: "20px" }}>
      {/* Vidéo de fond */}
      <video
        autoPlay
        loop
        muted
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: "-1",
          pointerEvents: "none",
          filter: "brightness(0.6) contrast(0.8) blur(1px)", // Réduction de la luminosité, contraste adouci et léger flou
        }}
      >
        <source src="/images/videos/5636838-uhd_3840_2160_30fps.mp4" type="video/mp4" />
        Votre navigateur ne supporte pas la lecture vidéo.
      </video>
  
      {/* Overlay pour assombrir davantage la vidéo */}
      <div
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.3)", // Couche sombre avec transparence
          zIndex: "-1",
        }}
      ></div>

        <div className="container" style={{ zIndex: "1" }}>
          <div className="row">
            <div className="contact-left">
              <h1 className="sub-title">{t("contactForm.title")}</h1>
              <p>
                <FontAwesomeIcon icon={faPaperPlane} className="fa-solid" />{" "}
                <a href="mailto:akamimehdi.dev@gmail.com">akamimehdi.dev@gmail.com</a>
              </p>
              <p>
                <FontAwesomeIcon icon={faPhoneSquare} className="fa-solid" />{" "}
                <a href="tel:+33699858005">+33 6 99 85 80 05</a>
              </p>
              <div className="social-icons">
                <a
                  href="https://www.linkedin.com/in/mehdi-akami-1912a51a9/"
                  aria-label="LinkedIn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faLinkedin} className="fa-brands" />
                </a>
                <a
                  href="https://github.com/akamidev"
                  aria-label="GitHub"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faGithub} className="fa-brands" />
                </a>
                <a
                  href="https://x.com/akamimehdi"
                  aria-label="Twitter"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faXTwitter} className="fa-brands" />
                </a>
              </div>
              <a
                href="images/CV_AKAMI_Mehdi.pdf"
                className="btn btn2"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("contactForm.downloadCV")}
              </a>
            </div>
            <div className="contact-right">
              <form name="contact" method="POST" data-netlify="true" onSubmit={handleSubmit}>
                <input type="hidden" name="form-name" value="contact" />
                <input
                  className="name"
                  type="text"
                  name="name"
                  placeholder={t("contactForm.namePlaceholder")}
                  pattern="[A-Za-z\s]+"
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <input
                  className="email"
                  type="email"
                  name="email"
                  placeholder={t("contactForm.emailPlaceholder")}
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <textarea
                  className="message"
                  placeholder={t("contactForm.messagePlaceholder")}
                  rows="6"
                  required
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                ></textarea>
                <input
                  type="text"
                  name="honeypot"
                  style={{ display: "none" }}
                  value={honeypot}
                  onChange={(e) => setHoneypot(e.target.value)}
                />
                {msg && <span className="msg">{t("contactForm.successMessage")}</span>}
                {errorMsg && <span className="error-msg">{errorMsg}</span>}
                <button type="submit" className="btn btn2" aria-label={t("contactForm.sendLabel")}>
                  {t("contactForm.sendButton")}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10476.958965051013!2d2.2746841250599785!3d48.96796057816373!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66627e3fe4405%3A0x40b82c3688b2db0!2s95210%20Saint-Gratien!5e0!3m2!1sfr!2sfr!4v1705407374987!5m2!1sfr!2sfr"
        width="1680"
        height="550"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Google Map"
      ></iframe>
    </>
  );
}

export default Contact;
